import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { languageController } from '../../../../controllers/language/languageController'
import { Svg } from '../../../1_Atoms/Svg/Svg'
import carDefault from '../../../../assets/images/jellyDefault.png';
import Image from '../../../1_Atoms/Image/Image'
// import parse from 'html-react-parser';
import Link from '../../../1_Atoms/Link/Link'
import { stripHTML } from '../../../../utils/helpers';

function ValueEstimateStep_TiE({
  currentVehicleData,
  desiredVehicleData,
  refreshSteps,
  language,
  buildAndPriceCtaLink
}) {
  const today = new Date();
  const monthLongName = today.toLocaleString(language === 'fr' ? 'fr-CA' : 'en-US', { month: 'long' });
  let priceRangeCopy = '';
  let tradeInValueBnP;

  // If both low and high are more than 0
  if (currentVehicleData.tradeInPriceLow > 0 && currentVehicleData.tradeInPriceHigh > 0) {
    priceRangeCopy = `$${currentVehicleData.tradeInPriceLow} - $${currentVehicleData.tradeInPriceHigh}`
    tradeInValueBnP = currentVehicleData.tradeInPriceLow;
  }
  // If low is more than 0 but high is 0 or minus
  else if (currentVehicleData.tradeInPriceLow > 0 && currentVehicleData.tradeInPriceHigh <= 0) {
    priceRangeCopy = `$${currentVehicleData.tradeInPriceLow}`
    tradeInValueBnP = currentVehicleData.tradeInPriceLow;
  }
  // If high is more than 0 but low is 0 or minus
  else if (currentVehicleData.tradeInPriceHigh > 0 && currentVehicleData.tradeInPriceLow <= 0) {
    priceRangeCopy = `$${currentVehicleData.tradeInPriceHigh}`
    tradeInValueBnP = currentVehicleData.tradeInPriceHigh;
  }

  return (
    <div className="mz-value-estimate-step-tie">
      <div className="mz-container">
        <h5 className="mz-value-estimate-step-tie__title grid-inner-content">{languageController.getCopy('tradeInEstimator', 'step5Title')}</h5>
        {
          currentVehicleData && (
            <div className="mz-estimate-callout grid-inner-content">
              <Svg type="trade_in_outlined" size={4} />
              <div className="mz-estimate-callout__top">
                <h1>{priceRangeCopy}</h1>
                <p className="label label--tight text--grey">{languageController.getCopy('global', 'asOf')} {monthLongName} {today.getFullYear()}</p>
              </div>
              <div className="mz-estimate-callout__middle">
                <p className="upper medium ls-md">{languageController.getCopy('tradeInEstimator', 'step5EstimateCopy1')}</p>
                <p className="medium mz-estimate-callout__current-vehicle-label">
                  {currentVehicleData.tradeInYear} {currentVehicleData.tradeInMake} {currentVehicleData.tradeInModel} {currentVehicleData.tradeInTrim}
                  <br />
                  {currentVehicleData.tradeInOdometer}Km
                </p>
                <a className="mz-estimate-callout__start-over-link mz-link mz-link--light-grey font-small ls-normal" onClick={refreshSteps}>{languageController.getCopy('tradeInEstimator', 'step5EditDetails')}</a>
              </div>
              {
                buildAndPriceCtaLink && (
                  <Fragment>
                    {/* TODO: Fix the lang when it's ready. How to handle this text in FR? */}
                    <p className="upper medium ls-md">See how much the {desiredVehicleData ? desiredVehicleData.title : ''} will cost with your trade-in value</p>
                    <Link
                      className="mz-btn mz-btn--primary"
                      text={languageController.getCopy('global', 'buildAndPrice')}
                      href={[
                        buildAndPriceCtaLink,
                        `?year=${encodeURIComponent(desiredVehicleData.year)}`,
                        `&preferred_vehicle_model_name=${encodeURIComponent(desiredVehicleData.model)}`,
                        `&trade_in_value=${encodeURIComponent(tradeInValueBnP)}`
                      ].join('')}
                    />
                  </Fragment>
                )
              }
            </div>
          )
        }
        <div className="mz-value-estimate-step-tie__vehicle grid-inner-content grid-inner-3-8-lg">
          <h4 className="mz-value-estimate-step-tie__vehicle-title">{languageController.getCopy('tradeInEstimator', 'step5Title2')}</h4>
          {
            desiredVehicleData && (
              <div className="mz-value-estimate-step-tie__vehicle-content">
                <Image className="mz-value-estimate-step-tie__vehicle-image mz-image--intrinsic-ratio" src={carDefault} alt={desiredVehicleData.title} isLazy={false} />
                <div className="mz-value-estimate-step-tie__vehicle-summary">
                  <h3 className="mz-value-estimate-step-tie__vehicle-name">{desiredVehicleData.year} {desiredVehicleData.title}</h3>
                  <p className="mz-value-estimate-step-tie__vehicle-description">
                    {desiredVehicleData.description ? stripHTML(desiredVehicleData.description) : ''}
                    {desiredVehicleData.msrp && (
                      <span className="mz-value-estimate-step-tie__vehicle-description-price">
                        <span> - </span>
                        {`${languageController.getCopy('global', 'startingFrom')} $${desiredVehicleData.msrp}`}
                      </span>
                    )}
                  </p>
                  {/* TODO: drives the user to the corresponding garage page */}
                  {/* URL for the button is provided by the API from the DB (controlled within the Build and Price CMS) */}
                  <Link className="mz-btn mz-btn--secondary" text={languageController.getCopy('global', 'learnMore')} href="#" />
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

ValueEstimateStep_TiE.propTypes = {
  currentVehicleData: PropTypes.object,
  desiredVehicleData: PropTypes.object,
  refreshSteps: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  buildAndPriceCtaLink: PropTypes.string.isRequired
}

ValueEstimateStep_TiE.defaultProps = {
  language: 'en'
}

export default ValueEstimateStep_TiE